/**
 * Shared configuration for AI suggestions functionality.
 * Used by AISuggestionTextField and file-based submission creation.
 */

export const AI_SUGGESTIONS_CONFIG = {
  ENABLED: false,
  MIN_CHARACTERS_FOR_SUGGESTIONS: 3,
  MIN_CONFIDENCE_THRESHOLD: 0.7,
  MAX_SUGGESTIONS_DISPLAYED: 10,
  SHOW_SOURCE_INFO: true,
  SHOW_ALL_OPTIONS: true,
  CREATE_SUBMISSION_FROM_FILE: true,
  ATTACH_FILES_TO_SUBMISSION: true,
  HIGHLIGHT_AI_FIELDS: true,
  HIGHLIGHT_COLOR: "#b040ff",
};

/**
 * Get suggestions configuration with fallback to defaults.
 *
 * @param {Object} configData - Configuration data from static data service
 * @returns {Object} Merged configuration
 */
export const getSuggestionsConfig = (configData) => {
  return configData ?? AI_SUGGESTIONS_CONFIG;
};
